import Router from "next/router";
import cookie from "js-cookie";
import { withCookie } from "next-cookie";
import SideBar from "../components/SideBar";
import styles from "../pages/admin/index.css";
import templateStyles from "../pages/admin/template.css";
import { UserProvider } from "./UserContext";
import { DOMAIN, SSO_BASE_URL } from "./constants";
import { apifetchv2, notify } from ".";

export const login = ({
  response,
  route,
  authenticationType,
  returnUrl = null,
}) => {

  try {
  const token = response.token;
  const expires =
    response.hasOwnProperty("expiry") && response.expiry
      ? new Date(response.expiry)
      : (1 / 48) * 2;
  const domain = `${DOMAIN}`;
  const cookieOptions = {
    expires,
    secure: process.env.ENVIRONMENT !== "development" ? true : false,
    domain,
  };
  cookie.set("expiry", response.expiry, cookieOptions);
  cookie.set("token", token, cookieOptions); 
  // cookie.set("user", JSON.stringify(response.user), cookieOptions);
  cookie.set(
    "user",
    JSON.stringify({
      email: response.user.email,
      firstname: response.user.firstname,
      lastname: response.user.lastname,
      phone: response.user.phone,
      isActive: response.user.isActive,
      hasConfirmed: response.user.hasConfirmed,
      roles: response.user.roles,
      isFirstUser: response.user.isFirstUser,
      cicodNumber: response.user.cicodNumber,
      apps: response.user.apps,
      subscriptionExpiry: response.user.subscriptionExpiry,
      isTrial: response.user.isTrial,
      merchantLogo: response.user.merchantLogo,
      tenantId: response.user.tenantId,
      merchantApps: response.user.merchantApps,
      kciInfo: response.user.kciInfo,
      merchantStatus: response.user.merchantStatus,
      isAccountLocked: response.user.isAccountLocked,
      emailConfirmed: response.user.emailConfirmed,
      tenantCategory: response.user.tenantCategory.slug,
    }),
    cookieOptions
  );
  // Set email into localStorage
  localStorage.setItem("email", response.user.email);
  cookie.set("authenticationType", authenticationType, cookieOptions);

  if (returnUrl && isValidURL(returnUrl)) {
    var query = /[?&]/.test(returnUrl)
      ? `&authorize=${token}`
      : `?authorize=${token}`;
    window.location.assign(`${returnUrl}${query}`);
  } else {
    const hasOnlyCom =
        Object.keys(response.user.apps).length === 1 && response.user.apps.com;
      const hasOnlySelfservice =
        response.user.businessStructures.length === 1 &&
        (response.user.businessStructures.find(
          (location) => location.city === "SELF-SERVICE"
        ) ||
          response.user.businessStructures.find(
            (structure) => structure.location === "SELF-SERVICE"
          ));
      const hasConfirmed = response.user.hasConfirmed;

      if (
        hasOnlyCom &&
        hasOnlySelfservice &&
        process.env.ENVIRONMENT !== "development" &&
        hasConfirmed
      ) {
        window.location.href = `//${response.user.apps.com}`;
        return;
      }

    window.location.href =
      process.env.ENVIRONMENT !== "development" ? `//${route}` : route;
  }
} catch (error) {
  console.error("Error while attempting to login", error)
  Router.push("/error-page");
}};

export const handleOTPVerification
= ({
  response,
  route,
  authenticationType,
  returnUrl = null,
}) => {
  const token = response.token;
  const expires =
    response.hasOwnProperty("expiry") && response.expiry
      ? new Date(response.expiry)
      : (1 / 48) * 2;
  const domain = `${DOMAIN}`;

 
};

export const handleLoginError = (response, attemptLeft, setAttemptLeft) => {
  if (response && response.status === "ACCOUNT_LOCKED") {
    return notify(
      "Too many retries. Your account has been locked, please contact your Administrator.",
      "ERROR"
    );
  }

  if (response && response.status === "INACTIVE_USER") {
    return notify("Your account has been suspended.", "ERROR");
  }

  if (response && response.status === "FAILED_VALIDATION") {
    return notify(response.data.message, "ERROR");
  }

  if (attemptLeft > 1) {
    setAttemptLeft(attemptLeft - 1);
    return notify(
      `Incorrect email or password. You have ${attemptLeft - 1} attempt${attemptLeft - 1 === 1 ? '' : 's'} left.`,
      "ERROR"
    );
  } else {
    return notify(
      "Too many retries. Your account has been locked, please contact your Administrator.",
      "ERROR"
    );
  }
};



export const isValidURL = (url) => {
  if (!url.trim()) return false;
  try {
    const $url = new URL(url);
    // return true for localhost
    if ($url.host.includes("localhost") || $url.host.includes("127.0.0.1")) {
      return true;
    }
    // any url that doesn't share the same domain e.g cicod.com should not be redirected to
    if (!$url.host.includes(DOMAIN)) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};

export const logout = () => {
  const token = cookie.get("token")
  const options = {
    url: `${SSO_BASE_URL}/auth/logout`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  apifetchv2(options).then((logoutResponse) => {
    if(!logoutResponse.status === 'SUCCESS') {
      notify('An error has occurred!', "ERROR")
      window.location.reload();
    }
    if(logoutResponse.status === 'SUCCESS') {
      window.location.replace(logoutResponse.returnUrl)
      return notify("Logout Successful", "SUCCESS")
    }
  })
  // const domain = `${DOMAIN}`;
  // const cookieOptions = {
  //   domain,
  // };
  // cookie.remove("token", cookieOptions);
  // cookie.remove("user", cookieOptions);
  // cookie.remove("authenticationType", cookieOptions);
  // cookie.remove("expiry", cookieOptions);
  // if (process.browser) {
  //   // to support logging out from all windows
  //   window.localStorage.setItem("logout", Date.now());
  // }
  // window.location.href = "/logout";
};

// Gets the display name of a JSX component for dev tools
const getDisplayName = (Component) =>
  Component.displayName || Component.name || "Component";

  // Function to clear cookies and localStorage
const clearAuthData = () => {
  // Clear cookies
  const cookies = ['token', 'user', 'authenticationType', 'expiry'];
  cookies.forEach(cookieName => {
    cookie.remove(cookieName);
  });

  // Clear localStorage
  if (typeof window !== 'undefined') {
    localStorage.removeItem("email");
  }
  
};

export const withAuth = (Component) =>
  withCookie(
    class extends React.Component {
      static displayName = `withAuth(${getDisplayName(Component)})`;

      static async getInitialProps(ctx) {
        const user = ctx.cookie.get("user");
        const expires = ctx.cookie.get("expiry");

        const props = auth(ctx);

        const componentProps =
          Component.getInitialProps && (await Component.getInitialProps(ctx));

        return {
          ...props,
          ...componentProps,
          authenticated: true,
          user,
          expires,
          // authenticationType: authenticationType
        };
      }

      componentDidMount() {
        document.getElementsByTagName("body")[0].className =
          "hold-transition cicod-theme sidebar-mini";
        window.addEventListener("storage", this.syncLogout);
      }

      componentWillUnmount() {
        window.removeEventListener("storage", this.syncLogout);
        window.localStorage.removeItem("logout");
      }

      syncLogout = (event) => {
        if (event.key === "logout") {
          clearAuthData();
          Router.push("/login");
        }
      };

      render() {
        const { cookie, authenticationType, token } = this.props;
        const user = cookie.get("user");

        return (
          <UserProvider
            user={{
              accessToken: token,
              authenticationType,
              ...user,
            }}
          >
            <SideBar />
            <Component {...this.props} />
            <style jsx>{templateStyles}</style>
            <style jsx>{styles}</style>
          </UserProvider>
        );
      }
    }
  );

const authorize = (ctx) => {
  if (ctx && ctx.pathname) {
    const user = ctx.cookie.get("user");
    if (
      ctx.pathname.includes("merchant/billing") &&
      user.roles !== "SUPERADMIN"
    ) {
      ctx.res.writeHead(302, { Location: "/admin/tenant" });
      ctx.res.end();
      return;
    }
  }
};

export const auth = (ctx) => {
  const token = ctx.cookie.get("token");
  const authenticationType = ctx.cookie.get("authenticationType");
  const user = ctx.cookie.get("user");


  /*
   * This happens on server only, ctx.req is available means it's being
   * rendered on server. If we are on server and token is not available,
   * means user is not logged in.
   */
  if (ctx.req && !token) {
    clearAuthData();
    ctx.res.writeHead(302, { Location: "/logout" });
    ctx.res.end();
    return;
  }

  // This should only happen on client.
  if (!token) {
    clearAuthData();
    Router.push("/logout");
  }

  if (
    user &&
    !user.hasConfirmed &&
    ctx.pathname !== "/admin/tenant/change-password"
  ) {
    if (ctx.pathname.includes("admin/tenant")) {
      if (ctx.req) {
        ctx.res.writeHead(302, { Location: "/admin/tenant/change-password" });
        ctx.res.end();
        return;
      }
      Router.push("/admin/tenant/change-password");
    }
  }

  authorize(ctx);

  return { token, authenticationType };
}; 
